<template>
  <!-- The one ClAlert host for confirm() and promptText(). Esc dismisses
       it first (OverlayHost's closeOverlay). -->
  <Teleport to="body">
    <ClAlert
      v-if="state.open"
      :key="state.title"
      :title="state.title"
      :body="state.body"
      :actions="state.actions"
      :field="state.field"
      @choose="choose"
      @dismiss="dismiss"
    />
  </Teleport>
</template>

<script>
import ClAlert from "@/components/kit/ClAlert.vue";
import { alertState, closeAlert } from "./confirm.js";

export default {
  name: "ConfirmHost",
  components: { ClAlert },
  data: () => ({ state: alertState }),
  methods: {
    choose(value) {
      closeAlert(value);
    },
    dismiss() {
      closeAlert(this.state.dismiss);
    },
  },
};
</script>
